<template>
  <section class="la-error-404">
    <h2 class="la-error-404__code">
      404
    </h2>
    <p class="la-error-404__message">
      {{ $t('pageNotFound') }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>
.la-error-404 {
  text-align: center;
  padding-bottom: 100px;
}

.la-error-404__code {
  color: #a7a7a7;
  text-transform: uppercase;
  font-family: "Body Text Large";
  font-size: 150px;
  font-weight: bold;
  text-align: center;
}

.la-error-404__message {
  color: #a7a7a7;
  font-family: "Body Text Large";
  font-size: 48px;
  font-weight: 400;
  margin-bottom: 0;
  padding-top: 22px;
}
</style>
